export const i18nCodeMap = {
  "WIDGET": {
      "USER_LOGIN_SLOGAN": {
          "code": "USER_LOGIN_SLOGAN",
          "message": "德比软件监控系统"
      },
      "USER_LOGIN_LABEL": {
          "code": "USER_LOGIN_LABEL",
          "message": "登录"
      },
      "USER_LOGIN_EMAIL": {
          "code": "USER_LOGIN_EMAIL",
          "message": "邮箱"
      },
      "USER_LOGIN_PASSWORD": {
          "code": "USER_LOGIN_PASSWORD",
          "message": "密码"
      },
      "USER_LOGIN_REMEMBER": {
          "code": "USER_LOGIN_REMEMBER",
          "message": "记住密码"
      },
      "USER_LOGIN_FORGET_PASSWORD": {
          "code": "USER_LOGIN_FORGET_PASSWORD",
          "message": "忘记密码？"
      },
      "USER_LOGIN_SIGN_IN": {
          "code": "USER_LOGIN_SIGN_IN",
          "message": "登录"
      },
      "USER_LOGIN_REGISTER_PART_ONE": {
          "code": "USER_LOGIN_REGISTER_PART_ONE",
          "message": "没有账号?"
      },
      "USER_LOGIN_REGISTER_PART_TWO": {
          "code": "USER_LOGIN_REGISTER_PART_TWO",
          "message": "马上注册"
      },
      "USER_LOGIN_REQIRED": {
          "code": "USER_LOGIN_REQIRED",
          "message": "不能为空"
      },
      "USER_RESET_LABEL": {
          "code": "USER_RESET_LABEL",
          "message": "忘记密码"
      },
      "USER_RESET_EMAIL": {
          "code": "USER_RESET_EMAIL",
          "message": "邮箱"
      },
      "USER_RESET_INSTRUCTIONS": {
          "code": "USER_RESET_INSTRUCTIONS",
          "message": "如果你忘记了密码或者需要重置密码，请填写帐号的邮箱地址，系统\n会发送重置密码的链接到你邮箱"
      },
      "USER_RESET_SEND_EMAIL": {
          "code": "USER_RESET_SEND_EMAIL",
          "message": "发送邮件"
      },
      "USER_RESET_BACK_LOGIN_PART_ONE": {
          "code": "USER_RESET_BACK_LOGIN_PART_ONE",
          "message": "已有账号?"
      },
      "USER_RESET_BACK_LOGIN_PART_TWO": {
          "code": "USER_RESET_BACK_LOGIN_PART_TWO",
          "message": "登录"
      },
      "USER_RESET_REQIRED": {
          "code": "USER_RESET_REQIRED",
          "message": "不能为空"
      },
      "USER_REGISTER_LABEL": {
          "code": "USER_REGISTER_LABEL",
          "message": "注册"
      },
      "USER_REGISTER_EMAIL": {
          "code": "USER_REGISTER_EMAIL",
          "message": "邮箱"
      },
      "USER_REGISTER_NAME": {
          "code": "USER_REGISTER_NAME",
          "message": "全名"
      },
      "USER_REGISTER_PASSWORD": {
          "code": "USER_REGISTER_PASSWORD",
          "message": "密码"
      },
      "USER_REGISTER_CONFIRM_PASSWORD": {
          "code": "USER_REGISTER_CONFIRM_PASSWORD",
          "message": "确认密码"
      },
      "USER_REGISTER_TITLE": {
          "code": "USER_REGISTER_TITLE",
          "message": "职级"
      },
      "USER_REGISTER_LANGUAGE": {
          "code": "USER_REGISTER_LANGUAGE",
          "message": "主要语言"
      },
      "USER_REGISTER_SELECT_LANGUAGE": {
          "code": "USER_REGISTER_SELECT_LANGUAGE",
          "message": "选择所需语言"
      },
      "USER_REGISTER_COMPANY_NAME": {
          "code": "USER_REGISTER_COMPANY_NAME",
          "message": "公司名称"
      },
      "USER_REGISTER_SIGN_UP": {
          "code": "USER_REGISTER_SIGN_UP",
          "message": "立即注册"
      },
      "USER_REGISTER_BACK_LOGIN_PART_ONE": {
          "code": "USER_REGISTER_BACK_LOGIN_PART_ONE",
          "message": "已有账号?"
      },
      "USER_REGISTER_BACK_LOGIN_PART_TWO": {
          "code": "USER_REGISTER_BACK_LOGIN_PART_TWO",
          "message": "登录"
      },
      "GENERAL_ACCOUNT_SETTINGS_LABEL": {
          "code": "GENERAL_ACCOUNT_SETTINGS_LABEL",
          "message": "用户设置"
      },
      "GENERAL_ACCOUNT_SETTINGS_ID": {
          "code": "GENERAL_ACCOUNT_SETTINGS_ID",
          "message": "用户标识"
      },
      "GENERAL_ACCOUNT_SETTINGS_EMAIL": {
          "code": "GENERAL_ACCOUNT_SETTINGS_EMAIL",
          "message": "邮箱"
      },
      "GENERAL_ACCOUNT_SETTINGS_NAME": {
          "code": "GENERAL_ACCOUNT_SETTINGS_NAME",
          "message": "全名"
      },
      "GENERAL_ACCOUNT_SETTINGS_ENTER_NAME": {
          "code": "GENERAL_ACCOUNT_SETTINGS_ENTER_NAME",
          "message": "输入全名"
      },
      "GENERAL_ACCOUNT_SETTINGS_TITLE": {
          "code": "GENERAL_ACCOUNT_SETTINGS_TITLE",
          "message": "职级"
      },
      "GENERAL_ACCOUNT_SETTINGS_ENTER_TITLE": {
          "code": "GENERAL_ACCOUNT_SETTINGS_ENTER_TITLE",
          "message": "输入职级"
      },
      "GENERAL_ACCOUNT_SETTINGS_LANGUAGE": {
          "code": "GENERAL_ACCOUNT_SETTINGS_LANGUAGE",
          "message": "主要语言"
      },
      "GENERAL_ACCOUNT_SETTINGS_SUBMIT": {
          "code": "GENERAL_ACCOUNT_SETTINGS_SUBMIT",
          "message": "保存"
      },
      "SECURITY_TWO_STEP_VERIFICATION_SUCCESS": {
          "code": "SECURITY_TWO_STEP_VERIFICATION_SUCCESS",
          "message": "成功"
      },
      "BILLING_DETAIL_EMAIL": {
          "code": "BILLING_DETAIL_EMAIL",
          "message": "邮箱"
      },
      "BILLING_DETAIL_ENTER_EMAIL": {
          "code": "BILLING_DETAIL_ENTER_EMAIL",
          "message": "输入邮箱"
      },
      "BILLING_DETAIL_SUBMIT": {
          "code": "BILLING_DETAIL_SUBMIT",
          "message": "保存"
      },
      "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_NEW_PASSWORD": {
          "code": "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_NEW_PASSWORD",
          "message": "新密码"
      },
      "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_PWD_BTN": {
          "code": "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_PWD_BTN",
          "message": "保存"
      },
      "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_PART_ONE": {
          "code": "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_PART_ONE",
          "message": "已有账号?"
      },
      "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_PART_TWO": {
          "code": "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_PART_TWO",
          "message": "登录"
      },
      "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_REQIRED": {
          "code": "TRANSFORM_CHANGE_EMAIL_INSTRUCTIONS_REQIRED",
          "message": "不能为空"
      },
      "TRANSFORM_CHANGE_LOGIN": {
          "code": "TRANSFORM_CHANGE_LOGIN",
          "message": "立即登录"
      },
      "TRANSFORM_RESET_PWD_LABEL": {
          "code": "TRANSFORM_RESET_PWD_LABEL",
          "message": "重置密码"
      },
      "TRANSFORM_RESET_PWD_BTN": {
          "code": "TRANSFORM_RESET_PWD_BTN",
          "message": "重置密码"
      },
      "TRANSFORM_RESET_PWD_LOGIN": {
          "code": "TRANSFORM_RESET_PWD_LOGIN",
          "message": "立即登录"
      },
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh-CN.js